import React from 'react'

function FormError(props) {
    return (
        <div>FormError</div>
    )
}

export default FormError